import {create} from 'zustand';


type CPEs_Managed_Card = {
    data: any;
    setData: (value:any) => void;

};

export const useCPEs_Managed_Card_Store = create<CPEs_Managed_Card>((set) => ({
    data: null ,
    setData: (value) => set({ data: value }),
}));


type Threats_mitigated_card = {
    data: any;
    setData: (value:any) => void;

};

export const useThreats_mitigated_cardStore = create<Threats_mitigated_card>((set) => ({
    data: null ,
    setData: (value) => set({ data: value }),
}));


type Devices_managed = {
    data: any;
    setData: (value:any) => void;

};

export const useDevices_managed = create<Devices_managed>((set) => ({
    data: null ,
    setData: (value) => set({ data: value }),
}));

type Mobile_with_app_card = {
    data: any;
    setData: (value:any) => void;

};

export const useMobile_with_app_card_Store = create<Mobile_with_app_card>((set) => ({
    data: null ,
    setData: (value) => set({ data: value }),
}));


type Table_widget = {
    data: any;
    setData: (value:any) => void;

};

export const useTable_widget_Store = create<Table_widget>((set) => ({
    data: null ,
    setData: (value) => set({ data: value }),
}));